var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
export const makeSessionRequest = (event, parameters) => __awaiter(void 0, void 0, void 0, function* () {
    try {
        const sessionId = localStorage.getItem("sessionId");
        const userString = localStorage.getItem("user");
        const currentUser = userString ? JSON.parse(userString) : undefined;
        if (currentUser) {
            axios.post(process.env.REACT_APP_HELLOAR_API + "app/session/event", {
                event: event,
                application_id: process.env.REACT_APP_APPLICATION_ID,
                account_id: currentUser.account_id,
                account_session_id: currentUser.session_id,
                viewer_id: process.env.REACT_APP_VIEWER_ID,
                session_id: sessionId,
                parameters: parameters,
            });
        }
    }
    catch (error) {
        console.error(error);
    }
});
